// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"ef75b227","882":"294bed94"}[chunkId] + ".chunk.js";
};